module.exports = __webpack_public_path__ + "img/consent-based-tracking.ce9b8a09.png";